import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, Heading, Text } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { colors, spaces } from '@99designs/emu/settings';

const Wrapper = styled.a`
    columns: 2 auto;
    width: 300px;
    cursor: pointer;
    color: ${colors.grey800};
    ${mediaQuery.only('small')} {
        padding: ${spaces['0.75bu']};
    }
    &:hover {
        text-decoration: none;
        outline: 0;
        color: ${colors.grey900};
    }
    &:focus {
        outline: 0;
        color: ${colors.grey900};
    }
    &:active {
        outline: 0;
        color: ${colors.grey900};
    }
`;

const Image = styled.img`
    width: 140px;
`;

interface Props {
    title: string;
    year: string;
    defaultImage: string;
    hoverImage: string;
    link: string;
}

export default function Card({ title, year, defaultImage, hoverImage, link }: Props) {
    const [imageSrc, setImageSource] = useState(defaultImage);
    return (
        <Wrapper
            href={link}
            target="_blank"
            onMouseOver={() => setImageSource(hoverImage)}
            onMouseOut={() => setImageSource(defaultImage)}
            data-testid={`${title}-${year}`}
        >
            <Image src={imageSrc} alt={title}></Image>
            <Box>
                <Heading accessibilityLevel={7} appearanceLevel={5}>
                    {title}
                </Heading>
            </Box>
            <Box paddingTop="0.75bu">
                <Text size="size3" color="none">
                    {year}
                </Text>
            </Box>
        </Wrapper>
    );
}
